import { Avatar, IconButton } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useParams } from "react-router-dom";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { CustomTab, CustomTabs } from "../../../components/tabs/Tabs";
import Shares from "./Shares";
import Meetups from "./Meetups";
import Members from "./Members";
import {
  getCommunityDetailsApi,
  getMemberListApi,
} from "../../../services/community";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import toast from "react-hot-toast";
import ModalBox from "../../../components/modal/ModalBox";
import { Button } from "../../../components/Button/Button";
import { catchMessage, elseMessage } from "../../../comman/Message";
import ChangeModerator from "./ChangeModerator";
import { PaginationShow } from "../../../comman/action/Pagination";
import { dateFormat } from "../../../components/Form";
import useButtonLoader from "../../../hooks/UseButtonLoader";
import { setJwtToken } from "../../../config/axiosInstance";
import axios from "axios";

const ViewDetailsComminity = () => {
  const { id } = useParams();
  const [communityDetails, setCommunityDetails] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [address, setAddress] = useState([]);
  const [addressModal, setAddressModal] = useState(false);
  const url = `${process.env.REACT_APP_API_URL}/admin/community/export_member?communityId=${id}`;
  const date = dateFormat(new Date());
  const [buttonref, buttonLoader] = useButtonLoader("Export Members list");

  // console.log("communityDetails?.", communityDetails?.locations[0]?.address)
  const tabValue = localStorage.getItem("tabsValue");
  const [type, setType] = useState(tabValue || "shares");
  const tab = localStorage.setItem("tabsValue", type);

  const [changeModeratorModal, setChangeModeratorModal] = useState(false);
  localStorage.setItem(
    "neptuneAdmin",
    JSON.stringify({
      name: "Neptune",
      role: "admin",
      username: "neptune_123",
      profile: "",
    })
  );
  const findNeptune = JSON.parse(localStorage.getItem("neptuneAdmin")) || {};
  // console.log("neptuneAdmin", findNeptune)

  //------------member------------
  const [membersList, setMembersList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  //----------------find-moderator----------------
  const findModerator = membersList
    .filter((data) => data.role === "moderator")
    .map((data) => data?.role);
  const moderator = findModerator.includes("moderator");

  const ModeratorBtn = useCallback(() => {
    const length = membersList?.length > 1;
    const admin = communityDetails?.createdBy == "admin";
    if (length && admin) {
      return (
        <Button onClick={() => setChangeModeratorModal(true)}>
          {moderator ? "Change Moderator" : "Add Moderator"}
        </Button>
      );
    }

    if (!admin && moderator) {
      return (
        <Button onClick={() => setChangeModeratorModal(true)}>
          Change Moderator
        </Button>
      );
    }
  }, [moderator, id, membersList]);

  //------------Handel-Pagination-------------
  const handlePageChange = (event) => {
    setPage(event);
  };
  //-----------------member-listing-Api----------------------------------
  const getMemberList = async (activePage = page) => {
    try {
      setMembersList([]);
      const res = await getMemberListApi(id, { page: activePage });
      if (res?.data?.status === 200) {
        let members = res?.data?.data?.memberList || [];
        let totalMembers = res?.data?.data?.total || 0;

        if (communityDetails?.createdBy === "admin") {
          // members = [...members, { name: "Neptune", role: "admin", username: "neptune_123", profile: "" }];
          members = [...members, findNeptune];
          totalMembers += 1;
        }
        setMembersList(members);
        setTotal(totalMembers);
      } else {
        elseMessage(res);
        setMembersList([]);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  //**********get community detail**********
  const getSingleCommunity = async () => {
    try {
      showLoader();
      const res = await getCommunityDetailsApi(id);
      hideLoader();
      if (res?.data?.status === 200) {
        setCommunityDetails(res?.data?.data?.community);
      } else {
        elseMessage(res);
        hideLoader();
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };
  useEffect(() => {
    getSingleCommunity();
  }, []);

  //---------------export-csv---------------------
  const downloadFile = async (url, fileName, params = {}) => {
    try {
      console.log("inner", url);
      buttonLoader(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      buttonLoader(false);
    }
  };

  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="row mb-3">
            <div className="col-6">
              <h4 className="Title">
                <Link to={-1}>
                  <IconButton>
                    <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
                  </IconButton>
                </Link>
                Community Details
              </h4>
            </div>
            <div className="col-6 d-flex">
              {/* <div className='mx-3'> <Button>Export Members list</Button></div> */}
              <button
                className="btn_size mx-3"
                ref={buttonref}
                onClick={() => downloadFile(url, `community${date}`)}
              >
                Export Members list
              </button>

              <Link
                to={`/community-circles/update-community/${id}`}
                className="Link-button"
              >
                <button className="btn_sizes mx-3">Edit Community</button>{" "}
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <Avatar
                variant="rounded"
                src={communityDetails?.coverImage}
                sx={{
                  width: 400,
                  height: 200,
                  border: 1,
                  borderRadius: 3,
                  borderColor: "#9dc4b4",
                }}
              >
                <InsertPhotoIcon sx={{ fontSize: 100 }} />
              </Avatar>
            </div>
            <div className="col-6">
              <div className="d-flex justify-content-between">
                <h4>{communityDetails?.communityName || "N/A"}</h4>
                {type === "members" && membersList?.length > 1 && (
                  <button
                    className="btn_sized mx-3"
                    onClick={() => setChangeModeratorModal(true)}
                  >
                    {moderator ? "Change Moderator" : "Add Moderator"}
                  </button>
                )}
                {/* {communityDetails?.createdBy !== 'admin' && moderator &&
                                    < Button onClick={() => setChangeModeratorModal(true)}>
                                        Change Moderator
                                    </Button>} */}
                {/* <ModeratorBtn /> */}
              </div>
              <p className="mt-2 mb-2">
                <LocationOnIcon sx={{ color: "#C86337" }} />
                {communityDetails?.locationType === "world" ? (
                  <b>{communityDetails?.locationType}</b>
                ) : (
                  <>
                    {/* <b>
                                            {`Country: ${communityDetails?.country?.name ?? "N/A"}, `}
                                            {`City: ${communityDetails?.city?.name ?? "N/A"}, `}
                                            {`Stats: ${communityDetails?.state?.name ?? "N/A"}`}
                                        </b> */}
                    <b>
                      {` ${communityDetails?.country?.name ?? "N/A"}, `}
                      {` ${communityDetails?.city?.name ?? "N/A"}, `}
                      {` ${communityDetails?.state?.name ?? "N/A"}`}
                    </b>
                  </>
                )}

                {/* <span>{address[0]?.address ? address[0]?.address : communityDetails?.locationType} </span>
                                {address.length > 1 && < span className='seeMore' onClick={() => setAddressModal(true)}>...view More</span>} */}
              </p>

              <p className="mt-2 mb-2 line-break">
                {(communityDetails?.about &&
                  communityDetails.about.replace(/\s+/g, " ")) ||
                  "N/A"}
              </p>

              {/* <p className='mt-2 mb-2 line-break'>{communityDetails?.about.trim() || "N/A"}</p> */}
              {/* <b>{communityDetails?.hashTag || '#Community'}</b> */}
            </div>
          </div>

          <div className="col-sm-12 col-form-label mx-auto mt-5">
            <CustomTabs
              value={type}
              onChange={(e, section) => {
                setType(section);
              }}
              aria-label="Content"
              variant="fullWidth"
            >
              <CustomTab value="shares" label="Shares" />
              {/* <CustomTab
                                value="privacy"
                                label="Privacy Policy"
                            /> */}
              <CustomTab value="meetups" label="Meetups" />
              <CustomTab value="members" label="Members" />
            </CustomTabs>
          </div>

          {type === "shares" && <Shares id={id} />}
          {type === "meetups" && <Meetups id={id} />}
          {type === "members" && (
            <Members
              id={id}
              membersList={membersList}
              getMemberList={getMemberList}
              page={page}
              total={total}
              handlePageChange={handlePageChange}
            />
          )}
        </div>
      </div>
      {/* ------------------Change-Moderator--------------- */}
      <ChangeModerator
        show={changeModeratorModal}
        close={() => setChangeModeratorModal(false)}
        id={id}
        newModerator={!moderator}
        listing={getMemberList}
      />

      {/* -----------more-than-one-address-then-open-in-modal-------- */}
      {/* <ModalBox
                status={addressModal}
                onClose={() => setAddressModal(false)}
                title="Location"
                custom
                customizedFooter={<Button onClick={() => setAddressModal(false)} >Close</Button>}
            >
                {address && address.map((data, index) => {
                    return (
                        <p className='mt-2 mb-2 d-flex' key={index}>
                            <LocationOnIcon sx={{ color: "#C86337" }} />
                            <span className='mx-1'>{data?.address ?? "N/A"} </span>
                        </p>
                    )
                })}
            </ModalBox> */}

      {/* ---------member-pagination------------- */}
      {/* <PaginationShow
                total={total}
                activePage={page}
                handlePageChange={handlePageChange}
            /> */}
    </>
  );
};

export default ViewDetailsComminity;
